import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

// COMPONENTS
import SignOutModal from "./SignOutModal";
import AuthMobileMenu from "./AuthMobileMenu";
// REDUX ACTIONS
import { login } from "../../redux/actions/auth";
// CSS STYLES
import styles from "../../styles/AuthenticationLogin/AuthNavbar.module.css"


const defaultImage = '/static/img/ImsLogos/IMS_Horizontal_Logo.png';

const AuthNavbar = ({
    // REDUX ACTIONS
    login,
    // REDUX REDUCERS
    auth: { 
        isAuthenticated, 
        accountUser 
    },
}) => {

    const navigate = useNavigate();

    const [openSignOutModal, setOpenSignOutModal] = useState(false);
    const [openMobileMenu, setOpenMobileMenu] = useState(false);
    const [hasAllAdminRoles, setHasAllAdminRoles] = useState(false);
    const [hasAddUsersPermission, setHasAddUsersPermission] = useState(false);


    // CHECK PERMISSIONS FOR ADMIN ROLES
    useEffect(() => {
        if (accountUser) {
            checkUserPermissionAdminRoles(accountUser);
        }
    }, [accountUser]);

    const checkUserPermissionAdminRoles = async (user) => {
        const requiredPermissions = ["addUsers", "manageRoles", "editUserPassword", "siteAdmin" ];

        const userPermissions = await user.permissions.map(permission => permission.permission);

        const hasAllPermissions = requiredPermissions.every(requiredPermission => 
            userPermissions.includes(requiredPermission)
        );

        const hasAddUsersPermission = userPermissions.includes('addUsers');

        if (hasAllPermissions) {
            setHasAllAdminRoles(true);
        }

        if (hasAddUsersPermission) {
            setHasAddUsersPermission(true);
        }
    }


    const handleNavbarButton = (btnType) => {
        if (btnType === 'Roles') {
            navigate(`/admin/roles`)
        } else if (btnType === 'Account') {
            navigate(`/admin/profile`)
        } else if (btnType === 'Users') {
            navigate(`/admin/users`)
        } else if (btnType === 'SignOut') {
            setOpenSignOutModal(true)
        }
    };


    const handleCloseSignOutModal = () => {
        setOpenSignOutModal(false)
    }


    const handleReturnHome = () => {
        if (window !== undefined) {
            window.location.replace('/auth/directory')
        }
    }

    return (
        <div className={styles.authNavbar_main_container}>
            {/* LOGO */}
            <img src={defaultImage} alt="IMS Logo" className={styles.authNavbar_logo} onClick={() => handleReturnHome()} />

            <div className={styles.authNavbar_links_container}>

                {hasAddUsersPermission &&
                    <p 
                        className={styles.authNavbar_single_link}
                        onClick={() => {handleNavbarButton('Users')}}
                    >
                        Users
                    </p>
                }

                {hasAllAdminRoles &&
                    <p 
                        className={styles.authNavbar_single_link}
                        onClick={() => {handleNavbarButton('Roles')}}
                    >
                        Roles
                    </p>
                }
                <p 
                    className={styles.authNavbar_single_link}
                    onClick={() => {handleNavbarButton('Account')}}
                >
                    Account
                </p>
                <p 
                    className={styles.authNavbar_single_link}
                    onClick={() => {handleNavbarButton('SignOut')}}
                >
                    Sign Out
                </p>
            </div>

            {/* MOBILE MENU */}
            <AuthMobileMenu openMenu={openMobileMenu} setOpenMenu={setOpenMobileMenu} handleNavbarButton={handleNavbarButton}/>


            <SignOutModal open={openSignOutModal} closeModal={handleCloseSignOutModal} />
        </div>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {
    login
})(AuthNavbar);
